import { Link } from "react-router-dom";
import { LOGO, COMPANY } from "@/lib/assets";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-foreground text-background">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <img src={LOGO} alt={COMPANY.name} className="h-12 w-auto object-contain bg-background/5 p-2 inline-block" />
            <h3 className="font-display text-4xl md:text-5xl mt-8 max-w-xl leading-[1.05]">
              Paper & paperboard, delivered with precision.
            </h3>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-background/50 mb-5">Navigate</p>
            <ul className="space-y-3">
              <li><Link to="/" className="link-underline text-background/90" data-testid="footer-home">Home</Link></li>
              <li><Link to="/blog" className="link-underline text-background/90" data-testid="footer-journal">Journal</Link></li>
              <li><Link to="/admin/login" className="link-underline text-background/60 text-sm" data-testid="footer-admin">Admin</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-background/50 mb-5">Contact</p>
            <ul className="space-y-3 text-background/90">
              <li><a href={`mailto:${COMPANY.email}`} className="link-underline inline-flex items-center gap-1" data-testid="footer-email">{COMPANY.email} <ArrowUpRight size={14} /></a></li>
              <li>{COMPANY.phone}</li>
              <li className="text-background/60 text-sm">{COMPANY.address}</li>
              <li className="text-background/40 text-xs font-mono2 pt-2">CIN: {COMPANY.cin}</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-background/15 flex flex-col md:flex-row justify-between gap-4 font-mono2 text-xs uppercase tracking-[0.15em] text-background/50">
          <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
          <span>Supply Chain · Paper · Paperboard</span>
        </div>
      </div>
    </footer>
  );
};
